import React from 'react';
import {
  CheckCircle,
  ClockCounterClockwise,
  User,
  Warning,
} from '@phosphor-icons/react';
import { Card, CardContent } from '../../components/ui/card';

/**
 * Compact 4-up KPI card row at the top of the audit-log page.
 * Renders nothing when summary hasn't loaded yet — caller should mount
 * unconditionally; the component decides whether to display.
 */
const StatCard = ({ icon: Icon, color, label, value }) => (
  <Card className="border-slate-200">
    <CardContent className="pt-4">
      <div className="flex items-center gap-3">
        <div className={`p-2 ${color} rounded-lg`}>
          <Icon size={24} />
        </div>
        <div>
          <p className="text-sm text-slate-500">{label}</p>
          <p className="text-2xl font-bold text-slate-900">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const AuditSummaryCards = ({ summary }) => {
  if (!summary) return null;
  const successRate = summary.total_logs > 0
    ? ((1 - summary.error_count / summary.total_logs) * 100).toFixed(1)
    : 100;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="audit-summary-cards">
      <StatCard
        icon={(p) => <ClockCounterClockwise {...p} className="text-indigo-600" />}
        color="bg-indigo-100"
        label="Total Events"
        value={summary.total_logs.toLocaleString()}
      />
      <StatCard
        icon={(p) => <User {...p} className="text-emerald-600" />}
        color="bg-emerald-100"
        label="Active Users"
        value={summary.unique_users}
      />
      <StatCard
        icon={(p) => <Warning {...p} className="text-amber-600" />}
        color="bg-amber-100"
        label="Errors"
        value={summary.error_count}
      />
      <StatCard
        icon={(p) => <CheckCircle {...p} className="text-blue-600" />}
        color="bg-blue-100"
        label="Success Rate"
        value={`${successRate}%`}
      />
    </div>
  );
};

export default AuditSummaryCards;
